"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.composeCostChartComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeCostChartComponent = function composeCostChartComponent(args) {
    var VictoryAxis = args.VictoryAxis,
        VictoryChart = args.VictoryChart,
        VictoryGroup = args.VictoryGroup,
        VictoryArea = args.VictoryArea,
        VictoryLabel = args.VictoryLabel;

    var CostChartComponent = function (_React$Component) {
        _inherits(CostChartComponent, _React$Component);

        function CostChartComponent() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, CostChartComponent);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CostChartComponent.__proto__ || Object.getPrototypeOf(CostChartComponent)).call.apply(_ref, [this].concat(args))), _this), _this._increaseMaxY = function (min, max) {
                return max + (max - min) / 10;
            }, _this._getContainerProps = function () {
                var newMaxY = _this._increaseMaxY(_this.props.data.min.y, _this.props.data.max.y);
                return {
                    responsive: true,
                    domain: {
                        y: [_this.props.data.min.y, newMaxY // this.props.data.max.y
                        ],
                        x: [_this.props.data.min.x, _this.props.data.max.x]
                    }
                };
            }, _this.renderXAxis = function () {
                // tickFormat={this.props.data.xGetLabel}
                return _react2.default.createElement(VictoryAxis, {
                    label: _this.props.labelX,
                    fixLabelOverlap: true,
                    style: _this.props.tickLabelsXStyle,
                    tickValues: _this.props.data.xLabels,
                    tickFormat: _this.props.data.xTickValues
                });
            }, _this.renderYAxisLabelNoY = function () {
                // transform={"translate(90 0 0)"}
                return _react2.default.createElement(VictoryLabel, {
                    textAnchor: "start",
                    transform: "rotate(90deg)" // TODO console error
                    , dy: -115,
                    dx: -40
                });
            }, _this.renderYAxisLabel = function () {
                return _react2.default.createElement(VictoryLabel, {
                    textAnchor: "start",
                    transform: "rotate(90deg)" // TODO console error
                    , dy: -110
                });
            }, _this.renderYAxis = function () {
                var _this$_getContainerPr = _this._getContainerProps(),
                    domain = _this$_getContainerPr.domain;

                var yAxisLabel = null;

                if (domain.y[0] === domain.y[1] && domain.y[0] === 0) {
                    yAxisLabel = _this.renderYAxisLabelNoY();
                    _this.props.tickLabelsYStyle.tickLabels.padding = -25;
                } else {
                    yAxisLabel = _this.renderYAxisLabel();
                    _this.props.tickLabelsYStyle.tickLabels.padding = 15;
                }

                return _react2.default.createElement(VictoryAxis, {
                    label: _this.props.labelY,
                    style: _this.props.tickLabelsYStyle,
                    axisLabelComponent: yAxisLabel,
                    tickValues: _this.props.data.yTickValues,
                    fixLabelOverlap: true,
                    dependentAxis: true
                });
            }, _this.renderData = function () {
                return _react2.default.createElement(VictoryArea, {
                    interpolation: _this.props.interpolation,
                    style: _this.props.dataStyle,
                    data: _this.props.data.items
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(CostChartComponent, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (this.props.data.items && this.props.data.items.length && !nextProps.data.items.length || nextProps.data.isLoading) {
                    return false;
                }
                return true;
            }

            // renderZoomContainer = () => {
            //     return (
            //         <VictoryZoomContainer
            //             dimension="x"
            //             zoomDomain={{
            //                 x: [this.props.data.min.x, this.props.data.max.x],
            //             }}
            //         />
            //     );
            // };

            // renderExpensiveData = () => {
            //     return (
            //         <VictoryArea
            //             interpolation={this.props.interpolation}
            //             style={this.props.expensiveDataStyle}
            //             data={this.props.expensiveData}
            //         />
            //     );
            // };

        }, {
            key: "render",
            value: function render() {
                if (this.props.data.min.x === this.props.data.max.x //||
                /*this.props.data.min.y === this.props.data.max.y*/) {
                        return null;
                    }

                return _react2.default.createElement(
                    VictoryChart,
                    this._getContainerProps(),
                    this.renderXAxis(),
                    this.renderYAxis(),
                    this.renderData()
                );
            }
        }]);

        return CostChartComponent;
    }(_react2.default.Component);

    CostChartComponent.propTypes = {
        interpolation: _react.PropTypes.string,
        data: _react.PropTypes.object,
        expensiveData: _react.PropTypes.object,
        opacity: _react.PropTypes.number,
        labelX: _react.PropTypes.string,
        labelY: _react.PropTypes.string,
        tickLabelsXStyle: _react.PropTypes.object,
        dataStyle: _react.PropTypes.object,
        expensiveDataStyle: _react.PropTypes.object
    };

    CostChartComponent.defaultProps = {
        //interpolation: 'cardinal',
        data: {
            min: {
                x: 0,
                y: 0
            },
            max: {
                x: 0,
                y: 0
            },
            items: []

        },
        expensiveData: {
            min: {
                x: 0,
                y: 0
            },
            max: {
                x: 0,
                y: 0
            },
            items: []
        },
        opacity: 1,
        labelX: '',
        labelY: 'kWh/h',
        tickLabelsXStyle: {
            // axisLabel: { fontSize: 14, padding: -10 },
            tickLabels: {
                fontSize: 14,
                padding: 15
                // padding: { right: 50, left: 50, top: 50, bottom: 50 }
            }
        },
        tickLabelsYStyle: {
            // axisLabel: { fontSize: 14, padding: { top: 20 } },
            tickLabels: {
                fontSize: 14,
                padding: 15
                // padding: { right: 50, left: 50, top: 50, bottom: 50 }
            }
        },
        dataStyle: {
            data: {
                stroke: '#75c71c',
                fill: '#75c71c'
            }
        },
        expensiveDataStyle: {
            data: {
                stroke: '#ffdbb7',
                fill: '#ffdbb7'
            }
        }
    };

    return CostChartComponent;
};

exports.composeCostChartComponent = composeCostChartComponent;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-charts/lib/charts/cost/CostChartComponent.js
// module id = 564
// module chunks = 0